import OrdenProduccionAPI from '@/api/produccion/ordenProduccion';

export default {
  namespaced: true,
  actions: {
    fetch_ordenes() {
      return OrdenProduccionAPI.index();
    },
    get_orden(_, id) {
      return OrdenProduccionAPI.show(id);
    },
    create_orden(_, data) {
      return OrdenProduccionAPI.create(data);
    },
    delete_orden(_, id) {
      return OrdenProduccionAPI.destroy(id);
    },
    iniciar_orden(_, payload) {
      const { id, maquina } = typeof payload === 'object' ? payload : { id: payload };
      return OrdenProduccionAPI.iniciar(id, maquina);
    },
    dividir_orden(_, { id, partes }) {
      return OrdenProduccionAPI.dividir(id, partes);
    },
    confirmar_orden(_, id) {
      return OrdenProduccionAPI.confirmar(id);
    },
    cancelar_orden(_, id) {
      return OrdenProduccionAPI.cancelar(id);
    },
    plan_produccion(_, ordenPreparacionId) {
      return OrdenProduccionAPI.plan(ordenPreparacionId);
    },
    plan_consolidado() {
      return OrdenProduccionAPI.planConsolidado();
    },
    generar_ordenes() {
      return OrdenProduccionAPI.generarOrdenes();
    },
    generar_ordenes_pedido(_, ordenPreparacionId) {
      return OrdenProduccionAPI.generarOrdenesPedido(ordenPreparacionId);
    },
    generar_ordenes_plan(_, lineas) {
      return OrdenProduccionAPI.generarOrdenesPlan(lineas);
    },
  },
};
